export enum DownloadMedicalCategory {
  ProviderNote = 'provider_note',
  ImagingResult = 'imaging_result',
  ProcedureNote = 'procedure_note',
  LabResult = 'lab_result',
  Medications = 'medications',
  PathologyResults = 'pathology_results',
  AdditionalRecords = 'additional_record',
}
